<template>
<div>
    <div class="container">
        <div class="h1 header">News &amp; Announcements</div>
        <div class="entry" v-for="entry in entries">
            <ul class="inline nospace small-text text-muted" style="margin-bottom: 4px">
                <li><img class="rounded" :src="entry.author.avatar" width="28px" height="28px" /></li>
                <li>{{ entry.author.name }}</li>
                <li>&bull;</li>
                <li>{{ entry.date }}</li>
            </ul>
            <div class="h2">{{ entry.title }}</div>
            <div v-html="entry.content"></div>
            <hr />
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'news',
    data () {
        return {
            entries: [
                {
                    author: {
                        name: 'Shinynecrid',
                        avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/a9/a97ee555e1e1b1dab04258b26e1a858e5db0e7dc_full.jpg'
                    },
                    title: 'Factorio!',
                    date: '25 Apr 2017',
                    content: '<p>We are hosting a Factorio server based on the latest Beta Release! Feel free to join us on 198.23.156.34(Server IP) and in discord!</p><p><a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a></p><p>Any questions let myself or another staff member know!</p>'
                },
                {
                    author: {
                        name: 'SilentSymphony',
                        avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/96/96485033c7c2eca148376e1be3694c2f9c97ff1c_full.jpg'
                    },
                    title: 'We\'re now officially supporting Avorion',
                    date: '01 Apr 2017',
                    content: '<p>I’m happy to announce that we’ll be supporting the space builder game Avorion with our new server The Verse!</p><p>Game Page: <a href="http://store.steampowered.com/app/445220/">http://store.steampowered.com/app/445220/</a></p><p>This game has very good ship building capabilities, which after over a month of play im still finding new ways to use it - you could build a flying shoe!</p><p>It also allows for a diverse styles of play to meet your goals and progress through the game such as scavenging, pirating, mining, hauling cargo and more options and even more to come in future patches!</p><p>We hope to see you on the server and the discord!</p><p>Server IP: <a href="http://theverse.ubrgmg.com">theverse.ubrgmg.com</a><br>Discord: <a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a></p>'
                },
                {
                    author: {
                        name: 'SilentSymphony',
                        avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/96/96485033c7c2eca148376e1be3694c2f9c97ff1c_full.jpg'
                    },
                    title: 'Sector Zero: Status Update',
                    date: '01 Apr 2017',
                    content: '<p>As im sure most of you know the development branch has finally been removed from the game and we are now all on a default branch again, If you have not already be sure to go into your SE’s beta tab and switch back to the normal version of space engineers.</p><p>Notes for that update are here: <a href="https://forums.keenswh.com/threads/update-01-178-3-minor-dead-drop-arena-new-update-release-system.7393571/">https://forums.keenswh.com/threads/update-01-178-3-minor-dead-drop-arena-new-update-release-system.7393571/</a></p><p>It’s been a little over 3 years of Sector Zero being online and i have no intention of stopping here after all this time, The new server software Torch seems to be coming along nicely and when its ready we’ll be switching to it, If you guys see Rexxar, Jimmacle be sure to thank them without their efforts we wouldnt still be here!</p><p>Remember to drop by our Discord <a href="https://discord.gg/0140zAqXoEaHJKmnX">https://discord.gg/0140zAqXoEaHJKmnX</a> as it is our central communications hub, if you need support, want to suggest changes, or just want to chat feel free to drop in and make yourself at home.</p>'
                }
            ]
        }
    },

    methods () {

    }
}
</script>

<style scoped lang="scss">
    .entry {
        &:last-child {
            hr {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// News.vue?fb92ac68